import { INPAGE_UI_STATE_CLEARED, MOVED_MODULE, RESET_HIGHLIGHTED_WIDGET_ID, UPDATE_COMPUTED_STYLES_FOR_SELECTORS, SELECTED_ITEM_UPDATED_STYLE_SECTION_TOUR_STEP, SELECTED_ITEM_UPDATED, UPDATE_HIGHLIGHTED_WIDGET_ID, UPDATE_SCROLL_TO_MODULE_ID, UPDATE_INPAGE_IS_DRAGGING_MODULE, UPDATE_INPAGE_MODE, PREVIEW_VIEWPORT_DIMENSIONS_UPDATED, PREVIEW_WRAPPER_SCROLL_UPDATED, INPAGE_PREVIEW_UNEXPECTEDLY_UNLOADED, TRACKED_FAILED_INPAGE_ASSETS, TRACKED_INPAGE_JS_LOADING_MULTIPLE_TIMES, DOM_READY_BLOCKING_RESOURCE_DETECTED, SET_IFRAME_LOADING, SET_IFRAME_NEEDS_REFRESH, PREVIEW_SCROLL_POSITION_CHANGED, CLEAR_USE_SCROLL_IF_MODULE_OUT_OF_BOUNDS_AT_ALL, CUSTOM_LAYOUT_SECTION_ADDED, CLEAR_SCROLL_TO_NODE_POSITION_INFO, UPDATE_NOPE_ZONE_SELECTOR, SCROLL_TO_LAYOUT_FRAGMENT } from 'ContentEditorUI/redux/actions/actionTypes';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
import { produce } from 'immer';
import mergeIn from '../../lib/mergeIn';
const initialState = {
  highlightedWidgetId: null,
  // Set when hovering over module list items to show where each module is on the page
  highlightedWidgetContainerId: null,
  // set when hovering over module list items so we can show where each container is on the page
  computedStylesBySelector: {},
  // Any computed styles needed for layout styles (fetched from iframe)
  mouseCoordsAndInfoFromLastBlur: null,
  inpageMode: InpageModes.DEFAULT,
  isDraggingModule: false,
  scrollToModuleId: null,
  // The id of the module to scroll the editor to
  scrollToNodePositionInfo: null,
  // The id of the node position to scroll the editor to
  previewViewportDimensions: {},
  // height and width of the "viewport" element that is the preview iframe's parent
  previewWrapperScroll: {},
  // scroll left of the preview wrapper  element
  inpagePreviewUnexpectedlyUnloaded: false,
  failedInpageAssets: [],
  domReadyBlockingResource: null,
  iframeNeedsRefresh: false,
  inpageJsLoadedMultipleTimes: false,
  previewScrollPosition: {
    left: 0,
    top: 0
  },
  useScrollIfModuleOutOfBoundsAtAll: false,
  nopeZoneSelector: null
};
const inpageReducer = (state = initialState, {
  type,
  payload
}) => produce(state, draft => {
  switch (type) {
    case INPAGE_UI_STATE_CLEARED:
      Object.assign(draft, {
        highlightedWidgetId: payload.highlightedWidgetId,
        inpageMode: payload.inpageMode || InpageModes.DEFAULT
      });
      return draft;
    case MOVED_MODULE:
      draft.highlightedWidgetId = null;
      return draft;
    case RESET_HIGHLIGHTED_WIDGET_ID:
      Object.assign(draft, {
        highlightedWidgetId: null,
        scrollToModuleId: null
      });
      return draft;
    case UPDATE_COMPUTED_STYLES_FOR_SELECTORS:
      {
        const {
          computedStylesBySelector
        } = payload;
        mergeIn(draft, ['computedStylesBySelector'], computedStylesBySelector);
        return draft;
      }
    case SELECTED_ITEM_UPDATED_STYLE_SECTION_TOUR_STEP:
    case SELECTED_ITEM_UPDATED:
      {
        const {
          id,
          shouldScrollToModule
        } = payload;
        const newState = {
          inpageMode: InpageModes.EDIT,
          highlightedWidgetId: null
        };
        if (shouldScrollToModule) {
          newState.scrollToModuleId = id;
        }
        Object.assign(draft, newState);
        return draft;
      }
    case UPDATE_HIGHLIGHTED_WIDGET_ID:
      {
        const {
          highlightedWidgetId,
          highlightedWidgetContainerId
        } = payload;
        const newState = {
          highlightedWidgetId,
          highlightedWidgetContainerId
        };
        Object.assign(draft, newState);
        return draft;
      }
    case CLEAR_USE_SCROLL_IF_MODULE_OUT_OF_BOUNDS_AT_ALL:
      {
        draft.useScrollIfModuleOutOfBoundsAtAll = false;
        return draft;
      }
    case UPDATE_SCROLL_TO_MODULE_ID:
      draft.scrollToModuleId = payload;
      return draft;
    case SCROLL_TO_LAYOUT_FRAGMENT:
      {
        const {
          nodePositionId,
          layoutSectionId
        } = payload;
        draft.scrollToNodePositionInfo = {
          nodePositionId,
          layoutSectionId
        };
        return draft;
      }
    case CUSTOM_LAYOUT_SECTION_ADDED:
      {
        const {
          rowIdToMove,
          layoutSectionId
        } = payload;
        draft.scrollToNodePositionInfo = {
          nodePositionId: rowIdToMove,
          layoutSectionId
        };
        return draft;
      }
    case CLEAR_SCROLL_TO_NODE_POSITION_INFO:
      {
        draft.scrollToNodePositionInfo = null;
        return draft;
      }
    case UPDATE_INPAGE_IS_DRAGGING_MODULE:
      Object.assign(draft, {
        isDraggingModule: payload.isDraggingModule
      });
      return draft;
    case UPDATE_INPAGE_MODE:
      draft.inpageMode = payload;
      return draft;
    case PREVIEW_VIEWPORT_DIMENSIONS_UPDATED:
      {
        const {
          width,
          height,
          iframeLeftOffset
        } = payload;
        draft.previewViewportDimensions = {
          width,
          height,
          iframeLeftOffset
        };
        return draft;
      }
    case PREVIEW_WRAPPER_SCROLL_UPDATED:
      {
        const {
          scrollLeft
        } = payload;
        draft.previewWrapperScroll = {
          scrollLeft
        };
        return draft;
      }
    case INPAGE_PREVIEW_UNEXPECTEDLY_UNLOADED:
      {
        draft.inpagePreviewUnexpectedlyUnloaded = true;
        return draft;
      }
    case TRACKED_FAILED_INPAGE_ASSETS:
      {
        draft.failedInpageAssets.push(...payload);
        return draft;
      }
    case TRACKED_INPAGE_JS_LOADING_MULTIPLE_TIMES:
      {
        draft.inpageJsLoadedMultipleTimes = true;
        return draft;
      }
    case DOM_READY_BLOCKING_RESOURCE_DETECTED:
      {
        draft.domReadyBlockingResource = payload;
        return draft;
      }
    case SET_IFRAME_LOADING:
      {
        // Reset failed inpage assets every time the iframe is reloaded
        Object.assign(draft, {
          failedInpageAssets: [],
          iframeNeedsRefresh: false,
          useScrollIfModuleOutOfBoundsAtAll: payload.scrollIfAnyBoundsOutOfView
        });
        return draft;
      }
    case SET_IFRAME_NEEDS_REFRESH:
      {
        draft.iframeNeedsRefresh = true;
        return draft;
      }
    case PREVIEW_SCROLL_POSITION_CHANGED:
      {
        const {
          left,
          top
        } = payload;
        draft.previewScrollPosition = {
          left,
          top
        };
        return draft;
      }
    case UPDATE_NOPE_ZONE_SELECTOR:
      {
        draft.nopeZoneSelector = payload;
        return draft;
      }
    default:
      return draft;
  }
});
export default inpageReducer;